import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'

const apiConst = {
  // 推荐视频列表
  recommended_video_list: baseAPI + baseUrl + 'official/recommended_video/list',
  // 推荐视频上传
  recommended_video_upload: baseAPI + baseUrl + 'official/recommended_video/upload',
  // 推荐视频更新
  recommended_video_update: baseAPI + baseUrl + 'official/recommended_video/update',
  // 推荐视频删除
  recommended_video_delete: baseAPI + baseUrl + 'official/recommended_video/delete',
  // 获取推荐视频国家列表
  recommended_video_countries: baseAPI + baseUrl + 'official/recommended_video/countries',
}

// 推荐视频列表
export const getRecommendedVideoList = async (params, data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.recommended_video_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    },
    data
  })
  return res
}

// 推荐视频上传
export const uploadRecommendedVideo = async (data, onUploadProgress) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.recommended_video_upload,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    },
    data,
    onUploadProgress
  })
  return res
}

// 推荐视频更新
export const updateRecommendedVideo = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.recommended_video_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    },
    data
  })
  return res
}

// 推荐视频删除
export const delRecommendedVideo = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.recommended_video_delete,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    },
    data
  })
  return res
}

// 获取推荐视频国家列表
export const getRecommendedCountry = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.recommended_video_countries,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}
